"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var parser_1 = require("@babel/parser");
var traverse_1 = __importDefault(require("@babel/traverse"));
var generator_1 = __importDefault(require("@babel/generator"));
var types = __importStar(require("@babel/types"));
var utils_1 = require("./utils");
var slot_1 = require("./vue/slot");
var attr_1 = require("./vue/attr");
var directives_1 = require("./vue/directives");
var event_1 = require("./vue/event");
/*
 https://vuejs.org/v2/guide/render-function.html

// @returns {VNode}
createElement(
  // {String | Object | Function}
  // An HTML tag name, component options, or async
  // function resolving to one of these. Required.
  'div',

  // {Object}
  // A data object corresponding to the attributes
  // you would use in a template. Optional.
  {
    // (see details in the next section below)
  },

  // {String | Array}
  // Children VNodes, built using `createElement()`,
  // or using strings to get 'text VNodes'. Optional.
  [
    'Some text comes first.',
    createElement('h1', 'A headline'),
    createElement(MyComponent, {
      props: {
        someProp: 'foobar'
      }
    })
  ]
)
https://github.com/vuejs/jsx#installation
//this 上 挂在 函数 大全
https://github.com/vuejs/vue/blob/dev/src/core/instance/render-helpers/index.js
function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode; [x]
  target._e = createEmptyVNode; [x]
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

*/
// Vue render h函数判断 
function isCreateElement(path, code) {
    var node = path.node;
    if (!types.isCallExpression(node) || !types.isStringLiteral(node.arguments[0]))
        return false;
    if (types.isIdentifier(node.callee)) {
        // @ts-ignore
        if (!path.scope.getBinding(node.callee.name))
            return false;
        if (!types.isVariableDeclarator(path.scope.getBinding(node.callee.name).path.node))
            return;
        // @ts-ignore
        return utils_1.getString(path.scope.getBinding(node.callee.name).path.node.init, code).includes("_self._c");
    }
    // (vm._self._c || )
    if (types.isLogicalExpression(node.callee)) {
        return utils_1.getString(node.callee, code).includes("_self._c");
    }
    return false;
}
// 通过搜索作用域范围内的关键词 判断 是否是render函数
function isRenderFunction(path) {
    var body = path.get("body.body");
    var _v = body[0];
    var _r = body[1];
    if (!/\_self\.\_c/.test(path.toString())) {
        return false;
    }
    if (_r && _v && types.isVariableDeclaration(_v.node) && types.isReturnStatement(_r.node) && /\$createElement/.test(_v.toString())) {
        return _r;
    }
    return false;
}
function BinaryExpressionToJSXText(path, childrens) {
    if (childrens === void 0) { childrens = []; }
    // path.node.operator 忽略 运算符 
    if (types.isStringLiteral(path.node.left)) {
        childrens.push(types.jsxText(path.node.left.value));
    }
    if (types.isBinaryExpression(path.node.left)) {
        BinaryExpressionToJSXText(path.get("left"), childrens);
    }
    if (types.isCallExpression(path.node.left)) {
        // @ts-ignore
        childrens.push(types.jsxExpressionContainer(path.node.left.arguments[0]));
    }
    if (types.isStringLiteral(path.node.right)) {
        childrens.push(types.jsxText(path.node.right.value));
    }
    if (types.isBinaryExpression(path.node.right)) {
        BinaryExpressionToJSXText(path.get("right"), childrens);
    }
    if (types.isCallExpression(path.node.right)) {
        // @ts-ignore
        childrens.push(types.jsxExpressionContainer(path.node.right.arguments[0]));
    }
    return childrens;
}
/*
export function isPrimitive (value: any): boolean %checks {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}
*/
function isPrimitive(path) {
    return types.isStringLiteral(path.node) || types.isNumericLiteral(path.node) || types.isBooleanLiteral(path.node);
}
function renderAttr(_b) {
    var attrobj = _b.attrobj, childrens = _b.childrens, attrs = _b.attrs;
    attrobj.node.properties.forEach(function (attr, index) {
        if (!types.isObjectProperty(attr))
            return;
        var keyString = attr.key.name || attr.key.value;
        if (["attrs", "props", "domProps"].includes(keyString)) {
            if (!types.isObjectExpression(attr.value))
                return;
            attr_1.parseAttr({ keyString: keyString, dg: dg, childrens: childrens, attrs: attrs, attr: attr });
        }
        else if (["directives"].includes(keyString)) {
            directives_1.parseDirectives({ attrs: attrs, attr: attr });
        }
        else if (["scopedSlots"].includes(keyString)) {
            var value = attrobj.get("properties." + index + ".value");
            slot_1.parseSlot({ value: value, dg: dg, childrens: childrens, attrs: attrs });
        }
        else if (["on", "nativeOn"].includes(keyString)) {
            attrs.push.apply(attrs, attrobj.get("properties." + index + ".value.properties").map(function (v) {
                return event_1.parseEvent({ key: v.get("key"), value: v.get("value"), pre: keyString });
            }));
        }
        else {
            attrs.push(types.jsxAttribute(types.jsxIdentifier(keyString), types.jsxExpressionContainer(attr.value)));
        }
    });
}
function dg(path, attr) {
    if (attr === void 0) { attr = []; }
    var _b;
    if (types.isConditionalExpression(path.node)) {
        var alternate = (_b = path.get("alternate")) === null || _b === void 0 ? void 0 : _b.toString();
        if (alternate && /\_e\(\)/.test(alternate)) {
            return dg(path.get("consequent"), [types.jsxAttribute(types.jsxIdentifier("vIf"), types.jsxExpressionContainer(path.node.test))]);
        }
    }
    if (!types.isCallExpression(path.node))
        return types.jsxText('');
    if (path.get("callee").toString().includes("_v")) { //createTextVNode _v
        var args_1 = path.get("arguments");
        if (args_1.length == 1 && types.isStringLiteral(args_1[0].node)) {
            return types.jsxText(args_1[0].node.value);
        }
        if (types.isExpression(args_1[0].node)) {
            if (types.isBinaryExpression(args_1[0].node)) {
                // @ts-ignore
                return BinaryExpressionToJSXText(args_1[0]);
            }
            return types.jsxExpressionContainer(args_1[0].node);
        }
        return types.jsxText("");
    }
    if (path.get("callee").toString().includes("_t")) { //renderSlot _t
        var args_2 = path.get("arguments");
        if (types.isStringLiteral(args_2[0].node)) {
            var slotAttrs = [types.jsxAttribute(types.jsxIdentifier("name"), args_2[0].node)], slotChildrens = [];
            if (args_2[2] && types.isObjectExpression(args_2[2].node)) {
                renderAttr({ childrens: slotChildrens, attrs: slotAttrs, attrobj: args_2[2] });
            }
            return utils_1.renderJSX({
                tagName: types.jsxIdentifier("slot"),
                // @ts-ignore
                attrs: slotAttrs,
                childrens: slotChildrens
            });
        }
        return types.jsxText('');
    }
    if (path.get("callee").toString().includes("_s(")) { //toString _s
        // @ts-ignore
        return types.jsxExpressionContainer(path.get("arguments.0"));
    }
    if (!types.isMemberExpression(path.node.arguments[0]) && !types.isStringLiteral(path.node.arguments[0]))
        return types.jsxText('');
    var node = path.node;
    // @ts-ignore
    var tagName = types.jsxIdentifier(node.arguments[0].value || node.arguments[0].name || "template");
    var attrs = __spreadArrays(attr);
    var childrens = [];
    var args = path.get("arguments");
    if (args[1] && types.isObjectExpression(args[1].node)) {
        var attrobj = args[1];
        renderAttr({ childrens: childrens, attrs: attrs, attrobj: attrobj });
    }
    attrs.forEach(function (v, index) {
        // if(!v){return}
        if (types.isJSXExpressionContainer(v.value) && types.isStringLiteral(v.value.expression)) {
            v.value = v.value.expression;
        }
        // @ts-ignore
        if (v.name.name == 'tag' && types.isMemberExpression(path.node.arguments[0])) {
            attrs.splice(index, 1);
            tagName = types.jsxIdentifier(v.value.value);
            // @ts-ignore
            attrs.push(types.jsxAttribute(types.jsxIdentifier("is"), types.jsxExpressionContainer(path.node.arguments[0])));
        }
    });
    // console.log(attrs)
    var childrenArgs = args[2];
    if (args[1] && (types.isArrayExpression(args[1]) || isPrimitive(args[1]))) {
        childrenArgs = args[1];
    }
    if (childrenArgs) {
        if (types.isArrayExpression(childrenArgs.node)) {
            // @ts-ignore
            childrens = childrens.concat(childrenArgs.get("elements").map(function (item) { return dg(item); }).flat());
        }
        else {
            if (types.isCallExpression(childrenArgs.node)) {
                childrens = childrens.concat([types.jsxExpressionContainer(childrenArgs.node)]);
            }
            else {
                if (types.isStringLiteral(childrenArgs.node)) {
                    childrens = childrens.concat([types.jsxText(childrenArgs.node.value)]);
                }
                else if (types.isExpression(childrenArgs.node) && !types.isObjectExpression(childrenArgs.node)) {
                    childrens = childrens.concat([types.jsxExpressionContainer(childrenArgs.node)]);
                }
            }
        }
    }
    return utils_1.renderJSX({
        tagName: tagName,
        attrs: attrs,
        childrens: childrens
    });
}
function default_1(code) {
    var ast = parser_1.parse(code, {
        plugins: ['jsx']
    });
    var opt = {
        // CallExpression: function a(path: NodePath<types.Node>, t: any) { 
        //   if (isCreateElement(path, code)) {
        //     path.replaceWith(dg(path));
        //   }
        // },
        Function: function (path, t) {
            var _r = isRenderFunction(path);
            if (_r) {
                var _a = _r.get("argument");
                // @ts-ignore
                _a.replaceWith(dg(_a));
            }
        }
    };
    // @ts-ignore
    traverse_1.default(ast, opt);
    var output = generator_1.default(
    // @ts-ignore
    ast, {
        jsescOption: {
            wrap: true,
            compact: false,
            indent: ' ',
            indentLevel: 2
        }
    }, code);
    return output.code;
}
exports.default = default_1;
//# sourceMappingURL=vue.js.map